/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next';
import { EditPositionPreferencesSection } from '../edit-position-preferences-section/edit-position-preferences-section.component';
import STRING_KEYS from '../../../../language/keys';
import { LocationSectionBody } from './location-section-body/location-section-body.component';
import { LocationSectionProps } from './location-section';

export const LocationSection = ({
  locations,
  remotePosition,
  changeHandler,
  remotePositionChangeHandler,
}: LocationSectionProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <EditPositionPreferencesSection
      emoji="🗺️"
      title={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.LOCATION) }
    >
      <LocationSectionBody
        locations={ locations }
        remotePosition={ remotePosition }
        changeHandler={ changeHandler }
        remotePositionChangeHandler={ remotePositionChangeHandler }
      />
    </EditPositionPreferencesSection>
  );
};
